import SectionHead from "./SectionHead";
import useLang from "../i18n/LanguageContext";
import "./About.css";

const About = () => {
  const { t } = useLang();
  const a = t.about;
  const l = a.label;

  const rows = [
    [l.model, "Mert Kerimi"],
    [l.layout, l.layoutValue],
    [l.switches, "Swift · React"],
    [l.since, "2022"],
  ];

  return (
    <section id="about" className="section">
      <div className="section__inner about">
        <div className="about__text">
          <SectionHead fkey="F4" title={a.title} />
          <p className="about__lead">{a.lead}</p>
          <p className="about__body">{a.body}</p>
        </div>

        {/* The sticker from the underside of a keyboard */}
        <div className="about__label" data-critter="label">
          <div className="about__label-head">
            <span className="about__label-model">MK-2026</span>
            <span className="about__label-role">{l.role}</span>
          </div>
          <dl className="about__specs">
            {rows.map(([k, v]) => (
              <div className="about__spec" key={k}>
                <dt>{k}</dt>
                <dd>{v}</dd>
              </div>
            ))}
            <div className="about__spec">
              <dt>{l.status}</dt>
              <dd className="about__ok">{l.statusValue}</dd>
            </div>
          </dl>
          <div className="about__barcode" aria-hidden="true" />
          <span className="about__serial">{l.serial}</span>
        </div>
      </div>
    </section>
  );
};

export default About;
